"use client";
import Script from "next/script";
import React from "react";

const DataLayer = () => {
  if (!process.env.NEXT_PUBLIC_GTM) return null;

  return (
    <>
      <Script
        id={"gtm-datalayer"}
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];`,
        }}
        strategy="afterInteractive"
      />
      <Script
        id={"gtm"}
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'${process.env.NEXT_PUBLIC_ANALYTICS_DOMAIN}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-${process.env.NEXT_PUBLIC_GTM}');`,
        }}
        strategy="afterInteractive"
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="${process.env.NEXT_PUBLIC_ANALYTICS_DOMAIN}/ns.html?id=GTM-${process.env.NEXT_PUBLIC_GTM}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
    </>
  );
};

export default DataLayer;
